import { Card, Checkbox, List, Radio } from "antd";
import styled from "styled-components";
import { CSS } from "@dnd-kit/utilities";
import { SortableContext } from "@dnd-kit/sortable";

//new style
export const ThemeQSTCard = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  background: ${({ theme }) => theme.settings.white};
  padding: 20px;
  &.backgroundColor {
    background: ${({ theme }) => theme.settings.cardBg};
  }
`;
// new style
export const ThemeQstTitle = styled.div`
  width: 100%;
  position: relative;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  color: ${({ theme }) => theme.settings.tertiary};
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  span {
    display: inline-block;
    margin-bottom: 10px;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    &.grayBG {
      background: rgba(${({ theme }) => theme.colors.rgbPrimary}, 0.1);
      border: 1px solid ${({ theme }) => theme.colors.borderColor};
      color: ${({ theme }) => theme.colors.primary};
    }
    &.orangeBG {
      background: rgba(${({ theme }) => theme.colors.rgbOrange}, 0.1);
      border: 1px solid ${({ theme }) => theme.colors.borderColor};
      color: rgba(${({ theme }) => theme.colors.rgbOrange}, 1);
    }
  }
`;
export const ThemeQstNumbers = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textColor};
  display: flex;
  align-items: center;
  gap: 10px;
  .numberCard {
    width: 30px;
    height: 30px;
    text-align: center;
    padding: 0px 2px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 30px;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    color: ${({ theme }) => theme.colors.secondary};
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover,
    &.active {
      background: ${({ theme }) => theme.colors.gradientBg};
      border: 1px solid ${({ theme }) => theme.colors.gradientBg};
      color: ${({ theme }) => theme.colors.white};
    }
    &:active {
      transform: scale(0.95);
    }
  }
`;
export const ThemeQstName = styled.div`
  width: 100%;
  position: relative;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  color: ${({ theme }) => theme.colors.secondary};
  &.strong {
    font-weight: 600;
  }
  &.largeFont {
    font-size: 20px;
    line-height: 28px;
  }
`;
export const ThemeRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  &.fullWidth {
    .ant-radio-wrapper {
      min-width: 100% !important;
    }
  }
  .ant-radio-wrapper {
    width: 100%;
    /* max-width: 75%; */
    background: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    padding: 12px 15px;
    border-radius: 10px;
    @media only screen and (max-width: 768.99px) {
      max-width: 100%;
    }
    input {
      font-weight: 400;
    }
    .ant-radio-label {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      color: ${({ theme }) => theme.colors.secondary};
    }
    .ant-radio-inner {
      border-color: ${({ theme }) => theme.colors.primary} !important;
      background-color: ${({ theme }) => theme.colors.white} !important;
      &:hover {
        border-color: ${({ theme }) => theme.colors.primary} !important;
      }
    }
    .ant-radio-checked {
      .ant-radio-inner {
        border-color: ${({ theme }) => theme.colors.primary} !important;
        background-color: ${({ theme }) => theme.colors.primary} !important;
      }
    }
    .ant-input-filled {
      background: transparent !important;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`;
export const ThemeCheckBoxGroup = styled(Checkbox.Group)`
  width: 100%;
  position: relative;
  .ant-checkbox-wrapper {
    width: 100%;
    /* max-width: 75%; */
    background: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    padding: 13px 15px;
    border-radius: 10px;
    @media only screen and (max-width: 768.99px) {
      max-width: 100%;
    }
    &:hover {
      .ant-checkbox-inner {
        border-color: ${({ theme }) => theme.colors.primary} !important;
      }
    }
  }
  .ant-checkbox-wrapper-checked {
    .ant-checkbox-inner {
      border-color: ${({ theme }) => theme.colors.primary} !important;
      background-color: ${({ theme }) => theme.colors.primary} !important;
    }
  }
  .ant-checkbox-wrapper-checked {
    .ant-checkbox-label {
      font-size: 14px;
      font-weight: 400;
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      color: ${({ theme }) => theme.colors.secondary};
    }
    .ant-checkbox-inner {
      background-color: ${({ theme }) => theme.colors.primary} !important;
    }
  }
  .ant-checkbox-wrapper-checked {
    .ant-checkbox-inner {
      background-color: ${({ theme }) => theme.colors.primary} !important;
    }
  }
`;
export const ThemeDragList = styled(List.Item)`
  width: 100%;
  /* max-width: 75%; */
  position: relative;
  display: block !important;
  cursor: auto;
  background: ${({ theme }) => theme.colors.white};
  transition: ${({ transition }) => transition};
  z-index: ${({ isDragging }) => (isDragging ? 100 : "auto")};
  background-color: ${({ isDragging }) =>
    isDragging
      ? `${({ theme }) => theme.colors.primary}`
      : `${({ theme }) => theme.colors.white}`};
  border-radius: 10px;
  padding: 8px 15px !important;
  border: 1px solid ${({ theme }) => theme.colors.borderColor} !important;
  margin-top: 8px !important;
  @media only screen and (max-width: 768.99px) {
    max-width: 100%;
  }
  .title {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    color: ${({ theme }) => theme.colors.secondary};
  }
  .dragPointer {
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.bodyBg} !important;
    float: right;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: grab;
    svg {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      font-family: ${({ theme }) => theme.fonts.inter} !important;
    }
  }
`;
export const ThemeDragListContext = styled(SortableContext)`
  width: 100%;
  position: relative;
`;
export const ThemeQstType = styled(Card)`
  border: none !important;
  background: transparent !important;
  .ant-card-body {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    padding: 5px 0px 0px 0px !important;
    @media only screen and (max-width: 768.99px) {
      grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    }
    &::before {
      display: none;
    }
  }
  .themeQstTypeGrid {
    background: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.borderColor} !important;
    border-radius: 10px;
    padding: 20px 10px !important;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.secondary};
    transition: all 0.2s ease;
    img,
    svg {
      margin: 10px auto;
      color: ${({ theme }) => theme.colors.secondary};
      filter: ${({ theme }) => theme.colors.imgFilterColor};
    }
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      border: 1px solid ${({ theme }) => theme.colors.primary} !important;
      transform: translateY(-2px);
    }
  }
  /* .ant-card-grid {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    width: 20%;
    position: relative;
    padding: 20px 10px !important;
    border-radius: 10px;
    margin: 0px 10px 10px 0px;
    border: 1px solid ${({ theme }) => theme.colors.borderColor} !important;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    color: ${({ theme }) => theme.colors.secondary};
    img,
    svg {
      margin: 10px auto;
      color: ${({ theme }) => theme.colors.secondary};
      filter: ${({ theme }) => theme.colors.imgFilterColor};
    }
  } */
`;
